import { Component } from "../base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { PageContext } from "../../service/PageContext";
import { DomUtil } from "../../util/DomUtil";
// import { ILandingPageLoadRequest } from "../../models/LandingPage/ILandingPageLoadRequest";

export class PublicationDateSelect extends Component {

  public _yearFilter: HTMLSelectElement;
  public _issueFilter: HTMLSelectElement;
  public _issueDates: any | undefined;
  public _issueIds: any | undefined;
  public _viewButton: HTMLButtonElement;

  constructor(element: HTMLElement, context: PageContext) {
    super(element, context);

    const query = DomUtil.queryAll.bind(null, element);

    this._yearFilter = <HTMLSelectElement>query("#yearSelect")[0];
    this._yearFilter.addEventListener("change",
      () => this.handleYearChanged(this._yearFilter)
    );

    this._issueFilter = <HTMLSelectElement>query("#issueSelect")[0];
    this._issueFilter.addEventListener("change",
      () => this.handleIssueChanged(this._issueFilter)
    );

    this._viewButton =
      <HTMLButtonElement>query(".button-nav__view-more > .btn")[0];
    this._viewButton.addEventListener("click",
      () => this.changeTableOfContents()
    );


    let data = this._element.dataset["issueDates"];
    if (data){
      this._issueDates = JSON.parse(data);
    } else {
      this._issueDates = undefined;
    }

    data = this._element.dataset["issueIds"];
    if (data){
      this._issueIds = JSON.parse(data);
    } else {
      this._issueIds = undefined;
    }

    var year = this._element.querySelector<HTMLInputElement>('#selectedYear');
    var issue = this._element.querySelector<HTMLInputElement>('#selectedIssue');

    if (year && issue && year.value && issue.value){
      this._yearFilter.value = year.value;
      this.handleYearChanged(this._yearFilter);
      this._issueFilter.value = issue.value;
      this.changeTableOfContents();
    }
  }

  public handleYearChanged(e: HTMLSelectElement): void {
    console.log("Year selected: " + e.value)
    if (!this._issueDates) {
      return;
    }
    let months = this._issueDates[e.value]?.split(',');
    if (months){
      this._issueFilter.innerHTML = "";
      months.forEach((month: string) => {
        var element = document.createElement("option");
        element.value = month;
        element.textContent = month;
        this._issueFilter.appendChild(element);
      });
    }

    var store = this._element.querySelector<HTMLInputElement>('#selectedYear');
    if (store){
      store.value = e.value;
    }
  }

  public async handleIssueChanged(e: HTMLSelectElement): Promise<void> {
    console.log("Issue selected: " + e.value)
    var issueStore = this._element.querySelector<HTMLInputElement>('#selectedIssue');
    if (issueStore){
      issueStore.value = e.value;
    }

    var yearStore = this._element.querySelector<HTMLInputElement>('#selectedYear');
    if (yearStore){
      yearStore.value = this._yearFilter.value;
    }
  }

  public async changeTableOfContents() : Promise<void> {
    console.log("Displaying new issue...")
    let toc = document.querySelector<HTMLElement>(".table-of-contents > .nav");
    if (toc){
      if (!this._issueIds){
        return
      }

      const key = this._yearFilter.value + "." + this._issueFilter.value;
      const issue = this._issueIds[key];

      var url = location.href.replace(location.search, '');
      url = `${url}?issue=${issue}`;

      window.location.href = url;
    }
  }
}

ComponentFactory.registerComponent("PublicationDateSelect",
    PublicationDateSelect);
